import serviceApi from '@/api/purchaseSalesCenter/outerServiceContract.js';
export default {
  methods: {
    // 按钮处理事件
    btnHandler(name) {
      this[name]();
    },
    // 提交按钮
    submit() {
      this.saveOrSubmitHandler(4);
    },
    // 保存按钮
    async save() {
      this.saveOrSubmitHandler(3);
    },
    // 保存/编辑/提交审批服务合同处理事件，operateFlag 0激活,1关闭,2申请撤销,3保存,4提交
    async saveOrSubmitHandler(operateFlag) {
      let postData = await this.getDetailData();
      if (this.isCopy) {
        delete postData.id;
        delete postData.contractCode;
        delete postData.contractStatus;
      }
      if (!postData.isViolationResponsibility) {
        delete postData.penaltyTypeValue;
        delete postData.penaltyDailyRate;
      }
      if (operateFlag == 4) {
        postData.oaId = this.userInfo.oaId;
      }
      console.log(postData, 'postData');
      if (!postData) return;
      this.loading.startLoading();
      const {
        data: { code, msg },
      } = await this.$axios.post(serviceApi.SAVE_OR_SUBMIT, {
        ...postData,
        operateFlag,
      });
      this.loading.endLoading();
      if (code === 0) {
        this.$message.success(msg);
        // 关闭当前的tag
        this.$store.dispatch('tagsView/delView', {
          path: '/salePurchase/serviceContractDetail',
          name: 'serviceContractDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push('/salePurchase/serviceContractList');
      } else {
        this.$message.error(msg);
      }
    },
    // 关闭/激活/申请撤销服务合同
    async closeOrActivateHandler(operateFlag) {
      let postData = await this.getDetailData();
      console.log(postData, 'postData');
      if (!postData) return;
      this.loading.startLoading();
      const {
        data: { code, msg },
      } = await this.$axios.post(serviceApi.ACTIVE_OR_CLOSE, {
        ...postData,
        operateFlag,
        oaId: this.userInfo.oaId,
      });
      this.loading.endLoading();
      if (code === 0) {
        this.$message.success(msg);
        // 关闭当前的tag
        this.$store.dispatch('tagsView/delView', {
          path: '/salePurchase/serviceContractDetail',
          name: 'serviceContractDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push('/salePurchase/serviceContractList');
      } else {
        this.$message.error(msg);
      }
    },
    // 取消按钮
    cancel() {
      const path = {
        path: '/salePurchase/serviceContractList',
        name: 'serviceContractList',
        meta: {
          keepAlive: false,
          title: '服务合同列表',
        },
      };
      // 关闭当前的tag
      this.$store.dispatch('tagsView/delView', {
        path: '/salePurchase/serviceContractDetail',
        name: 'serviceContractDetail',
        meta: {
          keepAlive: false,
          title: '',
        },
        query: {},
      });
      this.$router.push(path);
    },
    // 关闭合同按钮
    async close() {
      this.operateFlag = 1;
      this.$refs.closeOrActiveRef.openDialog();
    },
    // 激活合同按钮
    async activate() {
      this.operateFlag = 0;
      this.$refs.closeOrActiveRef.openDialog();
    },
    // 删除按钮
    delete() {
      this.deleteIds = [this.id];
      console.log(this.deleteIds, '删除的ids');
      this.$refs.deleteContractRef.openDialog();
    },
    // 复制按钮
    copy() {
      console.log('点击了复制按钮');
      const path = {
        path: 'salePurchase/serviceContractDetail',
        name: 'serviceContractDetail',
        meta: {
          keepAlive: false,
          title: '',
        },
        query: {
          id: this.id,
          status: 'create',
          isCopy: true,
        },
      };
      this.$router.push(path);
    },
    // 申请撤销按钮
    async revocation() {
      this.operateFlag = 2;
      this.$refs.closeOrActiveRef.openDialog();
    },
    // 确认撤销按钮
    async sureRevocation() {
      let postData = await this.getDetailData();
      console.log(postData, 'postData');
      if (!postData) return;
      const {
        data: { code, msg },
      } = await this.$axios.post(serviceApi.ACTIVE_OR_CLOSE, {
        ...postData,
        operateFlag: 2,
        revocationFlag: true,
      });
      if (code === 0) {
        this.$message.success(msg);
        // 关闭当前的tag
        this.$store.dispatch('tagsView/delView', {
          path: '/salePurchase/serviceContractDetail',
          name: 'serviceContractDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push('/salePurchase/serviceContractList');
      } else {
        this.$message.error(msg);
      }
    },
    // 驳回撤销按钮
    async cancelRevocation() {
      let postData = await this.getDetailData();
      console.log(postData, 'postData');
      if (!postData) return;
      const {
        data: { code, msg },
      } = await this.$axios.post(serviceApi.ACTIVE_OR_CLOSE, {
        ...postData,
        operateFlag: 2,
        revocationFlag: false,
      });
      if (code === 0) {
        this.$message.success(msg);
        // 关闭当前的tag
        this.$store.dispatch('tagsView/delView', {
          path: '/salePurchase/serviceContractDetail',
          name: 'serviceContractDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push('/salePurchase/serviceContractList');
      } else {
        this.$message.error(msg);
      }
    },
    // 获取页面表单表格数据
    async getDetailData() {
      // 1.表单数据
      let baseFormData = await this.$refs.baseInfoFormRef.getTableData();
      console.log(baseFormData, '基本信息表单');
      baseFormData.departmentCodes = [this.userInfo.departmentCode];
      baseFormData.adminFlag = this.userInfo.adminFlag;
      baseFormData.penaltyTypeValue = Number(baseFormData.penaltyTypeValue);
      baseFormData.penaltyDailyRate = Number(baseFormData.penaltyDailyRate);
      for (const key in baseFormData) {
        if (baseFormData[key] == ' ') baseFormData[key] = null;
      }
      // 2.附件
      const attachments = this.$refs.fileTableRef.getTableData();
      console.log(attachments, '上传的附件');
      const postData = {
        ...baseFormData,
        attachments,
      };
      return postData;
    },
  },
};
